import AccessTimeIcon from '@mui/icons-material/AccessTime';

function NotificationMsg(props:any) {
    const {msg} = props
    return (
        <div style={{ display:'flex', flexDirection:'row', alignItems: 'flex-start', justifyItems:'center' }}>
            <div><b>{'"' + msg + '"'}</b> is scheduled for processing. Check the <AccessTimeIcon style={{fontSize:'15px'}}/> <b>pending</b> section to track its progress</div>
        </div>  
    );
}

export default NotificationMsg;
